import React, {useState} from 'react';
import moment from 'moment';
/* import {find} from 'lodash'; */
import {useDispatch, useSelector} from 'react-redux';
import {
  Card,
  Table,
  Loader,
  Popup,
  Icon,
  Dimmer,
  Dropdown,
  Checkbox,
} from 'semantic-ui-react';
import {dateFormatShow} from '../../../common/constants/datesFormat';
import {pageSizes} from '../../../common/constants/lists';
import {Actions} from '../../../common/actions';
import OrdersByChassisModal from './modal/orders';
import TablePaginator from '../../../common/components/tablePaginator';

const OFFSET = 0;

const {
  changeListPage,
  changeListPageSize,
  fetchVehiclesAvailability,
  updateAvailabilityInVehicle,
} = Actions;

const Vehicle = ({
  index,
  vehicle,
  openOrdersByChassisModal,
  colors,
  dispatch,
}) => {
  const isPositive = vehicle.status === 'L';
  const isNegative = vehicle.qtyOpenOrders > 0;
  const prioritizationDateFormatted = vehicle.prioritizationDate ?
    moment(vehicle.prioritizationDate).format(dateFormatShow) :
    '';

  const handleAvailabilityChange = (chassis, data) => {
    const status = data.checked ? 'L' : 'P';
    dispatch(updateAvailabilityInVehicle(chassis, {status}));
  };

  /*  const getColorName = (color) => {
    if (!color) {
      return;
    }
    const colorData = find(colors, {'name': color});
    return colorData ? colorData.description : '';
  }; */

  return (
    <Table.Row
      key={index}
      textAlign='center'
      positive={isPositive}
      negative={isNegative}
    >
      <Table.Cell className='chassis-column'>{vehicle.chassis}</Table.Cell>
      <Table.Cell>
        {vehicle.sfx}/{vehicle.katashiki}
      </Table.Cell>
      <Table.Cell>{vehicle.description}</Table.Cell>
      <Table.Cell>{vehicle.color}</Table.Cell>
      <Table.Cell>{prioritizationDateFormatted}</Table.Cell>
      <Table.Cell>
        <Checkbox
          toggle
          checked={vehicle.status === 'L'}
          disabled={vehicle.status === 'P' && vehicle.qtyOpenOrders > 0}
          label={vehicle.status === 'L' ? 'Si' : 'No'}
          onChange={(e, data) => handleAvailabilityChange(vehicle.chassis, data)}
        />
      </Table.Cell>
      <Table.Cell className='actions-column'>
        <Popup
          trigger={
            <span className='link'>
              <Icon
                name='eye'
                size='big'
                onClick={() => openOrdersByChassisModal(vehicle.chassis)}
              />
            </span>
          }
          content='Visualizar Órdenes'
          position='top center'
          inverted
        />
      </Table.Cell>
    </Table.Row>
  );
};

const TableInformation = ({
  vehicles,
  loading,
  openOrdersByChassisModal,
  colors,
  dispatch,
}) => {
  if (loading) {
    return (
      <Table.Row>
        <Table.Cell colSpan='100%'>
          <Loader active inline='centered' />
        </Table.Cell>
      </Table.Row>
    );
  }

  if (!vehicles.length) {
    return (
      <Table.Row textAlign='center'>
        <Table.Cell colSpan={7}>
          No hay vehículos disponibles con los filtros seleccionados
        </Table.Cell>
      </Table.Row>
    );
  }

  return vehicles.map((item, index) => (
    <Vehicle
      key={index}
      index={index}
      vehicle={item}
      colors={colors}
      openOrdersByChassisModal={openOrdersByChassisModal}
      dispatch={dispatch}
    />
  ));
};

const Detail = ({parameters}) => {
  const [ordersModalWasOpen, setOrdersModalWasOpen] = useState(false);
  const [chassisSelected, setChassisSelected] = useState('');
  const vehiclesAvailability = useSelector(
    (state) => state.vehiclesAvailability
  );
  const dispatch = useDispatch();
  const {
    pageSize,
    pageNumber,
    itemsCount,
    loading,
    list,
    colors,
    updating,
  } = vehiclesAvailability;

  const onPageClick = (value) => {
    dispatch(changeListPage(value));
    dispatch(fetchVehiclesAvailability(parameters, pageSize, value));
  };

  const onPageSizeClick = (event, data) => {
    dispatch(changeListPageSize(data.value));
    dispatch(fetchVehiclesAvailability(parameters, data.value, OFFSET));
  };

  const closeStockDownloadModal = () => {
    setOrdersModalWasOpen(false);
    setChassisSelected('');
  };

  const openOrdersByChassisModal = (chassis) => {
    setOrdersModalWasOpen(true);
    setChassisSelected(chassis);
  };

  return (
    <Card raised fluid>
      {chassisSelected && (
        <OrdersByChassisModal
          modalWasOpen={ordersModalWasOpen}
          chassis={chassisSelected}
          onCloseModal={() => closeStockDownloadModal()}
        />
      )}

      {updating && (
        <Dimmer active inverted>
          <Loader inverted inline='centered' content='Actualizando' />
        </Dimmer>
      )}

      <Table>
        <Table.Header>
          <Table.Row textAlign='center'>
            <Table.HeaderCell className='chassis-column'>
              Chasis
            </Table.HeaderCell>
            <Table.HeaderCell>Katashiki</Table.HeaderCell>
            <Table.HeaderCell>Descripción</Table.HeaderCell>
            <Table.HeaderCell>Color</Table.HeaderCell>
            <Table.HeaderCell>Fecha Priorización</Table.HeaderCell>
            <Table.HeaderCell>Listo</Table.HeaderCell>
            <Table.HeaderCell>Acciones</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          <TableInformation
            loading={loading}
            vehicles={list}
            colors={colors}
            dispatch={dispatch}
            openOrdersByChassisModal={openOrdersByChassisModal}
          />
        </Table.Body>

        {itemsCount > pageSize && (
          <Table.Footer>
            <Table.Row textAlign='center'>
              <Table.HeaderCell colSpan='100%'>
                <div className='table-pagination'>
                  <span className='page-sizer'>
                    <strong>Items por página</strong>
                    <Dropdown
                      selection
                      upward
                      compact
                      value={pageSize}
                      options={pageSizes}
                      onChange={onPageSizeClick}
                    />
                  </span>
                  <TablePaginator
                    itemsCount={itemsCount}
                    itemsPerPage={pageSize}
                    selectedPage={pageNumber}
                    onOptionClick={onPageClick}
                  />
                </div>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        )}
      </Table>
    </Card>
  );
};

export default Detail;
